import type { ListViewPage, SortDirection } from './listViewTypes';

import type { Customer } from './customerTypes';
import type { Deal } from './dealTypes';
import type {
  BasePurchaseOrder,
  PurchaseOrderStatus,
  PurchaseOrderTotals,
} from './materialsListTypes';
import type { Supplier } from './supplierTypes';
import type { User } from './userTypes';

export type ListedPurchaseOrder = BasePurchaseOrder &
  PurchaseOrderTotals & {
    predictedTotalExcludingTax?: number;
    predictedTotal?: number;
    status: PurchaseOrderStatus;
    supplier: Pick<Supplier, 'id' | 'name'>;
    deal?: Pick<Deal, 'id' | 'reference' | 'customReference'> & {
      customer?: Pick<Customer, 'id' | 'name'>;
    };
  };

export enum SortBy {
  REFERENCE = 'reference',
  SENT_AT = 'sentAt',
}

export type GetListedPurchaseOrdersQueryParams = {
  pageNumber: number;
  pageSize: number;
  sortBy: SortBy;
  sortDirection: SortDirection;
  searchTerm?: string;
  supplierIds?: Supplier['id'][];
  dealAssigneeIds?: User['id'][];
};

export type ListedPurchaseOrdersPage = ListViewPage<ListedPurchaseOrder>;
